export default __webpack_public_path__ + "images/7da1250a25ca30cd88934505f0035bb8.png";